import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export function reactivation({ msisdn }: { msisdn: string }) {
  return axios.post(`${API_URL}operation/reanundacion-linea`, {
    msisdn,
  });
}

export async function getAll(filters: any) {
  const response = await axios.get(`${API_URL}catalogos/reanundacion-linea`);
  const data = response.data.doc.data;
  return data;
}
